export const queryParams = window.location.search
  .replace("?", "")
  .split("&")
  .map(i => i.split("="))
  .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

queryParams.hash = window.location.hash.replace("#", "");
